import React from 'react';
import Button from '@mui/material/Button';
import { MdSearch } from 'react-icons/md';

let BuscarButton = (props) => {
    return (
        <Button
            disabled={props.disabled}
            onClick={() => props.onClick()}
            variant="contained">
            <MdSearch />
        </Button>
    );
}

export default BuscarButton;

  

